import { HEADER_HEIGHT } from './Layout';

const HEIGHT = { desktop: HEADER_HEIGHT, mobile: HEADER_HEIGHT };

export function useHeaderHeight(): { desktop: number; mobile: number } {
	return HEIGHT;
}
